import {
  Capability,
  CapabilityKeys,
  SelfServePlan,
  SelfServePlanFromApi,
  SelfServicePlanTier,
} from '@hcs/types';

const getTierNameFromPlanName = (planName: string): SelfServicePlanTier => {
  if (planName.startsWith('Teams')) {
    return 'Teams';
  }
  if (planName.startsWith('Pro')) {
    return 'Pro';
  }
  return 'Basic';
};

export const processSelfServePlan = (
  planRaw: SelfServePlanFromApi,
  capabilities: Partial<Record<CapabilityKeys, Capability>> | undefined,
): SelfServePlan => {
  const planCapabilities: Partial<Record<CapabilityKeys, Capability>> = {};
  const planProductDetails: SelfServePlan['product_details'] = {};
  if (capabilities) {
    planRaw.capabilities?.forEach((capabilityKey) => {
      const capability = capabilities[capabilityKey];
      if (capability) {
        planCapabilities[capabilityKey] = capability;
      }
    });
  }
  planRaw.product_details?.forEach((productDetail) => {
    if (productDetail.product_key) {
      planProductDetails[productDetail.product_key] = productDetail;
    }
  });
  const plan: SelfServePlan = {
    ...planRaw,
    name: getTierNameFromPlanName(planRaw.name),
    product_details: planProductDetails,
    capabilities: planCapabilities,
  };
  return plan;
};
